<div class="row">
  <div class="col-md-12">
    <div style="display: block; height: 150px;">
      <canvas #chartCanvas></canvas>
    </div>
  </div>
  <div class="col-md-12" style="display: flex; justify-content: center;">
    <div><b>Total Estimated Tonnage</b>: {{ item.tonnage?.total }}</div>
  </div>
</div>
